import tourConfig from '../common/tour/config';

const tourSteps = (language) => {
  let tourOptions = tourConfig.getOptions(language);
  tourOptions.steps = [
    {
      element: '.main-container-tabs',
      intro: language.tour.taskManagerTour.general,
      position: 'right'
    },
    {
      element: '.main-without-tabs',
      intro: language.tour.taskManagerTour.general,
      position: 'right'
    },
    {
      element: '.react-tabs__tab-list',
      intro: language.tour.taskManagerTour.tabList,
      position: 'bottom'
    },
    {
      element: '.tour-tab__task_manager_tab_tasks',
      intro: language.tour.taskManagerTour.tabTasks,
      position: 'bottom'
    },
    {
      element: '.tour-tab-badge__task_manager_tab_tasks',
      intro: language.tour.taskManagerTour.tabTasksBadge,
      position: 'bottom'
    },
    {
      element: '.tour-tab__task_manager_tab_notifications',
      intro: language.tour.taskManagerTour.tabNotifications,
      position: 'bottom'
    },
    {
      element: '.tour-header-filter__categories',
      intro: language.tour.taskManagerTour.categoriesFilter,
      position: 'bottom'
    },
    {
      element: '.tour-header-filter__dateStart',
      intro: language.tour.taskManagerTour.dateStartFilter,
      position: 'bottom'
    },
    {
      element: '.tour-header-filter__dateEnd',
      intro: language.tour.taskManagerTour.dateEndFilter,
      position: 'bottom'
    },
    {
      element: '.tour-header-filter__person',
      intro: language.tour.taskManagerTour.personFilter,
      position: 'bottom'
    },
    {
      element: '.tour-header-filter__desviationType',
      intro: language.tour.taskManagerTour.typeFilter,
      position: 'bottom'
    },
    {
      element: '.tour-top-charts__task_manager_tab_tasks',
      intro: language.tour.taskManagerTour.distribution,
      position: 'bottom'
    },
    {
      element: '.total-tasks-total',
      intro: language.tour.taskManagerTour.quantity,
      position: 'left'
    },
    {
      element: '.total-tasks-notifications',
      intro: language.tour.taskManagerTour.quantity,
      position: 'left'
    },
    {
      element: '.annull_button',
      intro: language.tour.taskManagerTour.annullButton,
      position: 'right'
    },
    {
      element: '.tasks_manager_second_filters',
      intro: language.tour.taskManagerTour.tableFilters,
      position: 'bottom'
    },
    {
      element: '.stateFilter',
      intro: language.tour.taskManagerTour.stateFilter,
      position: 'bottom'
    },
    {
      element: '.managerFilter',
      intro: language.tour.taskManagerTour.manageByFilter,
      position: 'bottom'
    },
    {
      element: '.vehicleFilter',
      intro: language.tour.taskManagerTour.vehicleFilter,
      position: 'bottom'
    },
    {
      element: '.workingShiftGroupFilter',
      intro: language.tour.taskManagerTour.workingShiftGroupFilter,
      position: 'bottom'
    },
    {
      element: '.th-OccurrenceDate',
      intro: language.tour.taskManagerTour.ocurrenceDateColumn,
      position: 'right'
    },
    {
      element: '.th-CreatedDate',
      intro: language.tour.taskManagerTour.createDateColumn,
      position: 'right'
    },
    {
      element: '.th-ClosedDate',
      intro: language.tour.taskManagerTour.closeDateColumn,
      position: 'right'
    },
    {
      element: '.th-TaskType',
      intro: language.tour.taskManagerTour.typeColumn,
      position: 'bottom'
    },
    {
      element: '.th-Subtype',
      intro: language.tour.taskManagerTour.subtypeColumn,
      position: 'bottom'
    },
    {
      element: '.th-Person',
      intro: language.tour.taskManagerTour.personColumn,
      position: 'bottom'
    },
    {
      element: '.th-Vehicle',
      intro: language.tour.taskManagerTour.vehicleColumn,
      position: 'bottom'
    },
    {
      element: '.th-Manager',
      intro: language.tour.taskManagerTour.manageByColumn,
      position: 'left'
    },
    {
      element: '.th-State',
      intro: language.tour.taskManagerTour.stateColumn,
      position: 'left'
    },
    {
      element: '.modal-indicators-info-tour',
      intro: language.tour.taskManagerTour.helpIcon,
      position: 'right'
    },
    {
      element: '.th-CreatedDate .sort-icons',
      intro: language.tour.taskManagerTour.sortIcon,
      position: 'right'
    },
    {
      element: '.module-table tbody tr',
      intro: language.tour.taskManagerTour.tableRow,
      position: 'top'
    },
    {
      element: '.excel-buttons',
      intro: language.tour.taskManagerTour.excelButton,
      position: 'left'
    }
  ];

  return tourOptions;
};

export default tourSteps;


// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/tourSteps.js